const custOrganization = {
    path: 'custOrganization',
    name: 'custOrganization',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'organization',
        icon: 'HSIconfont hs-icon-org',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custOrganizationManage',
            name: 'custOrganizationManage',
            component: () => import('@/views/custOrganizationManage'),
            meta: { code: 'organization:organizationManage' }

        },
        {
            path: 'custStores',
            name: 'custStores',
            component: () => import('@/views/custStores'),
            meta: { code: 'organization:store' }

        },
        {
            path: 'custStoresMap',
            name: 'custStoresMap',
            component: () => import('@/views/custStoresMap'),
            meta: { code: 'organization:storesMap' }

        },
    ]
};

export default custOrganization;
